import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {MerchantUser} from "./MerchantUserStore";
import {UserProfile} from "../UserProfileStore";
import {Merchant} from "../MerchantStore";
import {StemDate} from "../../../stem-core/time/Date";

@globalStore
export class MerchantStaff extends BaseStore("MerchantStaff", {dependencies: ["MerchantUser"]}) {
    @field(Number) merchantId: number;
    @field("Merchant") merchant: Merchant;
    @field("UserProfile") user: UserProfile;
    @field(Date) createdAt: StemDate;
    // @field(Date) lastModifiedAt; // TODO add in backend and her
    @field("UserProfile") createdBy: UserProfile;
    @field(Boolean) isOwner: boolean;
    @field(Boolean) hasEditPermissions: boolean;

    getMerchantUser(): MerchantUser {
        return MerchantUser.getFromObject(this);
    }

    getEmail(): string {
        return this.getMerchantUser().email;
    }
}

export async function apiMerchantCreateStaffMember(request: any): Promise<any> {
    return apiClient.post("/merchant/create_staff_member", request);
}

export async function apiMerchantEditStaffMember(request: any): Promise<any> {
    return apiClient.post("/merchant/edit_staff_member", request);
}

export async function apiMerchantDeleteStaffMember(request: any): Promise<any> {
    return apiClient.post("/merchant/delete_staff_member", request);
}